import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import moment from 'moment'
import Cookies from 'js-cookie'
import { getDict,subscribeList,topicCount,Arefreshlogin,getMeta } from '@/service'


const Home = () => import(/* webpackChunkName: 'pc' */ './views/Home')
const Viewer = () => import(/* webpackChunkName: 'pc' */ './views/Viewer')
// const Index = () => import(/* webpackChunkName: 'pc' */ './views/Index/Index.vue')
// const OrgApply = () => import(/* webpackChunkName: 'pc' */ './views/OrgApply.vue')

const NewsList = () => import(/* webpackChunkName: 'pc' */ './views/News/NewsList')
// import NewsList from './views/News/NewsList.vue'
const NewsDetail = () => import(/* webpackChunkName: 'pc' */ './views/News/NewsDetail')
const AttentionIndex = () => import(/* webpackChunkName: 'pc' */ './views/Attention/AttentionIndex')
const OrgDetail = () => import(/* webpackChunkName: 'pc' */ './views/Org/OrgDetail')
const CompanyDetail = () => import(/* webpackChunkName: 'pc' */ './views/Company/CompanyDetail')
const CompanyCompare = () => import(/* webpackChunkName: 'pc' */ './views/Company/CompanyCompare')
const PeoDetail = () => import(/* webpackChunkName: 'pc' */ './views/Peo/PeoDetail')
const FinancingIndex = () => import(/* webpackChunkName: 'pc' */ './views/Financing/FinancingIndex')
const SpecialList = () => import(/* webpackChunkName: 'pc' */ './views/Special/SpecialList')
const SpecialNewsList = () => import(/* webpackChunkName: 'pc' */ './views/Special/SpecialNewsList.vue')
const SpecialDetail = () => import(/* webpackChunkName: 'pc' */ './views/Special/SpecialDetail')
const AllLogoMap = () => import(/* webpackChunkName: 'pc' */ './views/Special/AllLogoMap')
const PreviewSpecialDetail = () => import(/* webpackChunkName: 'pc' */ './views/Special/SpecialDetail')
const BriefReport = () => import(/* webpackChunkName: 'pc' */ './views/BriefReport/BriefReport')
const PreviewBriefReport = () => import(/* webpackChunkName: 'pc' */ './views/BriefReport/BriefReport')

const Scientific = () => import(/* webpackChunkName: 'pc' */ './views/Scientific/Scientific')

const EventList = () => import(/* webpackChunkName: 'pc' */ './views/DataList/EventList')
const MergersList = () => import(/* webpackChunkName: 'pc' */ './views/DataList/MergersList')
const CompanyList = () => import(/* webpackChunkName: 'pc' */ './views/DataList/CompanyList')
const OrgList = () => import(/* webpackChunkName: 'pc' */ './views/DataList/OrgList')
const HospitalList = () => import(/* webpackChunkName: 'pc' */ './views/DataList/HospitalList')
const ParkList = () => import(/* webpackChunkName: 'pc' */ './views/DataList/ParkList')
const HospitalDetail = () => import(/* webpackChunkName: 'pc' */ './views/Hospital/HospitalDetail')
const TenderList = () => import(/* webpackChunkName: 'pc' */ './views/DataList/TenderList')
// const DiddingList = () => import(/* webpackChunkName: 'pc' */ './views/DataList/DiddingList')
const TenderDetail = () => import(/* webpackChunkName: 'pc' */ './views/Tender/TenderDetail')
const PolicyList = () => import(/* webpackChunkName: 'pc' */ './views/DataList/PolicyList')
const PolicyDetail = () => import(/* webpackChunkName: 'pc' */ './views/Policy/PolicyDetail')

const SearchList = () => import(/* webpackChunkName: 'pc' */ './views/Search/SearchList')
const OrderList = () => import(/* webpackChunkName: 'pc' */ './views/Order/OrderList')
const OpenInv = () => import(/* webpackChunkName: 'pc' */ './views/Order/OpenInv')
const BuyVip = () => import(/* webpackChunkName: 'pc' */ './views/Order/BuyVip')
const UserAccount = () => import(/* webpackChunkName: 'pc' */ './views/User/UserAccount')
const UserMain = () => import(/* webpackChunkName: 'pc' */ './views/User/UserMain')

const ReportList = () => import(/* webpackChunkName: 'pc' */ './views/Report/ReportList')
const ReportDetail = () => import(/* webpackChunkName: 'pc' */ './views/Report/ReportDetail')
// const UserReport = () => import(/* webpackChunkName: 'pc' */ './views/Report/UserReport')

const UserProduct = () => import(/* webpackChunkName: 'pc' */ './views/User/UserProduct')
const UserCoupon = () => import(/* webpackChunkName: 'pc' */ './views/User/UserCoupon')

const ActivityList = () => import(/* webpackChunkName: 'pc' */ './views/Activity/ActivityList')
const ActivityDetail = () => import(/* webpackChunkName: 'pc' */ './views/Activity/ActivityDetail')
const NotFound = () => import(/* webpackChunkName: 'pc' */ './views/NotFound')

const WorkBench = () => import(/* webpackChunkName: 'pc' */ './views/WorkBench/WorkBench')
const FeedList = () => import(/* webpackChunkName: 'pc' */ './views/WorkBench/FeedList')
const UserCollect = () => import(/* webpackChunkName: 'pc' */ './views/User/UserCollect')

const Log = () => import(/* webpackChunkName: 'pc' */ './views/Log/Log')
const HelpCenter = () => import(/* webpackChunkName: 'pc' */ './views/HelpCenter/HelpCenter')
const About = () => import(/* webpackChunkName: 'pc' */ './views/About/About')

const NoticeList = () => import(/* webpackChunkName: 'pc' */ './views/DataList/NoticeList') //公告
const ProspectusList = () => import(/* webpackChunkName: 'pc' */ './views/DataList/ProspectusList') //招股书
const ActList = () => import(/* webpackChunkName: 'pc' */ './views/DataList/ActList') //活动
const ProductList = () => import(/* webpackChunkName: 'pc' */ './views/DataList/ProductList') //产品
const NoticeDetail = () => import(/* webpackChunkName: 'pc' */ './views/Notice/NoticeDetail') //公告详情
const IndustryList = () => import(/* webpackChunkName: 'pc' */ './views/DataList/IndustryList') // 行业数据
const StockList = () => import(/* webpackChunkName: 'pc' */ './views/DataList/StockList') // 股票列表
const FinanceList = () => import(/* webpackChunkName: 'pc' */ './views/DataList/FinanceList') // 财务数据列表

const Contact = () => import(/* webpackChunkName: 'pc' */ './views/Form/Contact') // 信息收集表单

/**
 * 官网改版-查赛道
 * @returns 
 */
const searchTrack = () => import(/* webpackChunkName: 'pc' */ './views/Competitive/SearchTrack') //查赛道
const orgLikesTrack = () => import(/* webpackChunkName: 'pc' */  './views/Competitive/OrgLikesTrack.vue') //查赛道-机构青睐赛道
const ipoList = () => import(/* webpackChunkName: 'pc' */  './views/Competitive/IpoList.vue') //查赛道-ipo进行时
const trackList = () => import(/* webpackChunkName: 'pc' */ './views/Competitive/TrackList.vue') //查赛道-赛道动态
const trackDetail = ()=> import(/* webpackChunkName: 'pc' */ './views/Competitive/TrackDetail.vue') //查赛道-赛道详情

/**
 * 官网改版-看报告
 * @returns 
 */
const reportingDetail = () => import(/* webpackChunkName: 'pc' */  './views/Reporting/ReportingDeatil.vue')
const chartSet = () => import(/* webpackChunkName: 'pc' */  './views/Reporting/chartSet.vue')
/**
 * 官网改版
 * @returns 
 */
const CompanyFilter = () => import(/* webpackChunkName: 'pc' */ './views/CompanyFilter/CompanyFilter') // 财务数据列表
const CompanyMore = () => import(/* webpackChunkName: 'pc' */ './views/CompanyFilter/CompanyMore') // 找公司查看更多页面
const Collect = () => import(/* webpackChunkName: 'pc' */ './views/Collect/Collect') // 财务数据列表
const MyAttention = () => import(/* webpackChunkName: 'pc' */ './views/Attention/MyAttention') // 财务数据列表

// 动脉网
const Main = () => import(/* webpackChunkName: 'pc' */ './views/Main/Main') // 动脉网信息流首页
const ArticleDetail = () => import(/* webpackChunkName: 'pc' */ './views/Main/ArticleDetail') // 动脉网信息流首页

// 登录监听
const LoginTarget = () => import(/* webpackChunkName: 'pc' */ './views/LoginCommon/LoginTarget') 
// 申请试用
const ApplyTry = () => import(/* webpackChunkName: 'pc' */ './views/ApplyTry/ApplyTry') 
// 直播
const Live = () => import(/* webpackChunkName: 'pc' */ './views/Main/Live') 
const LiveTheme = () => import(/* webpackChunkName: 'pc' */ './views/Live/LiveTheme') 
const LiveList = () => import(/* webpackChunkName: 'pc' */ './views/Live/LiveList') 
const Login = () => import(/* webpackChunkName: 'pc' */ './views/Login/Login') 

const Santen = () => import(/* webpackChunkName: 'pc' */ './views/Exterior/Santen.vue') 
const Proofing = () => import(/* webpackChunkName: 'pc' */ './views/Exterior/Proofing.vue') 
const BD = () => import(/* webpackChunkName: 'pc' */ './views/Exterior/BD.vue') 
const Newsletter = () => import(/* webpackChunkName: 'pc' */ './views/Exterior/Newsletter.vue') 
const EnNewsletter = () => import(/* webpackChunkName: 'pc' */ './views/Exterior/EnNewsletter.vue') 
const SearchNewsletter = () => import(/* webpackChunkName: 'pc' */ './views/Exterior/SearchNewsletter.vue') 
const EnSearchNewsletter = () => import(/* webpackChunkName: 'pc' */ './views/Exterior/EnSearchNewsletter.vue') 

const Privacy = () => import(/* webpackChunkName: 'pc' */ './components/vcbeat/Privacy.vue')

const MedicineList = () => import(/* webpackChunkName: 'pc' */ './views/Medicine/MedicineList.vue')
const MedicineDetail = () => import(/* webpackChunkName: 'pc' */ './views/Medicine/MedicineDetail.vue')


Vue.use(Router)
const router = new Router({
  mode: 'history',
  base: '',
  routes: [
    // {path: '/', name: 'Index', meta: {keepAlive: false, pc: true, type: 1}, component: Index}, 
    // {path: '/orgApply', name: 'OrgApply', meta: {keepAlive: false, pc: true, type: 1}, component: OrgApply},    
    {path: '/loginTarget', name: 'LoginTarget', meta: {keepAlive: false, pc: true, type: 1}, component: LoginTarget}, 
    {path: '/login', name: 'Login', meta: {keepAlive: false, pc: true, type: 1}, component: Login}, 
    {path: '/viewer', name: 'Viewer', meta: {keepAlive: false, pc: true, type: 1}, component: Viewer}, 
    {path: '/santen', name: 'Santen', meta: {keepAlive: false, pc: true, type: 1}, component: Santen},
    {path: '/proofing', name: 'Proofing', meta: {keepAlive: false, pc: true, type: 1}, component: Proofing},
    {path: '/BD', name: 'BD', meta: {keepAlive: false, pc: true, type: 1}, component: BD},
    {path: '/newsletter', name: 'Newsletter', meta: {keepAlive: false, pc: true, type: 1}, component: Newsletter},
    {path: '/ennewsletter', name: 'EnNewsletter', meta: {keepAlive: false, pc: true, type: 1}, component: EnNewsletter},
    {path: '/searchNewsletter', name: 'SearchNewsletter', meta: {keepAlive: false, pc: true, type: 1}, component: SearchNewsletter},
    {path: '/ensearchNewsletter', name: 'EnSearchNewsletter', meta: {keepAlive: false, pc: true, type: 1}, component: EnSearchNewsletter},
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: { pc: true, type: 1 },
      children: [
        {path: 'main2', name: 'Main', meta: {keepAlive: false, pc: true, type: 1}, component: Main},
        {path: 'newsList', name: 'NewsList', meta: {keepAlive: false, pc: true, type: 1}, component: NewsList},
        {path: 'newsDetail/:uid', name: 'NewsDetail', meta: {keepAlive: false, pc: true, type: 1}, component: NewsDetail},
        {path: 'attentionIndex', name: 'AttentionIndex', meta: {keepAlive: false, pc: true, type: 1}, component: AttentionIndex,
          beforeEnter: (to, from, next) => {
            store.commit('updateFromName', from.name)
            next()
          }
        },
        {path: 'orgDetail/:uid', name: 'OrgDetail', meta: {keepAlive: false, pc: true, type: 1}, component: OrgDetail},
        {path: 'companyDetail/:uid', name: 'CompanyDetail', meta: {keepAlive: false, pc: true, type: 1}, component: CompanyDetail},
        {path: 'compare', name: 'CompanyCompare', meta: {keepAlive: false, pc: true, type: 1}, component: CompanyCompare},
        {path: 'peoDetail/:uid', name: 'PeoDetail', meta: {keepAlive: false, pc: true, type: 1}, component: PeoDetail},
        {path: 'financing', name: 'FinancingIndex', meta: {keepAlive: false, pc: true, type: 1}, component: FinancingIndex},
        {path: 'specialList', name: 'SpecialList', meta: {keepAlive: true, pc: true, type: 1}, component: SpecialList},
        {path: 'specialDetail/:uid', name: 'SpecialDetail', meta: {keepAlive: false, pc: true, type: 1}, component: SpecialDetail},
        {path: 'allLogoMap', name: 'AllLogoMap', meta: {keepAlive: false, pc: true, type: 1}, component: AllLogoMap},
        {path: 'specialNewsList/:uid', name: 'SpecialNewsList', meta: {keepAlive: false, pc: true, type: 1}, component: SpecialNewsList},
        {path: 'previewSpecialDetail', name: 'PreviewSpecialDetail', meta: {keepAlive: false, pc: true, type: 1}, component: PreviewSpecialDetail},
        {path: 'briefReport/:uid', name: 'BriefReport', meta: {keepAlive: false, pc: true, type: 1}, component: BriefReport},
        {path: 'previewBriefReport/:uid', name: 'PreviewBriefReport', meta: {keepAlive: false, pc: true, type: 1}, component: PreviewBriefReport},
        {path: 'scientific', name: 'Scientific', meta: {keepAlive: false, pc: true, type: 1}, component: Scientific},
        {path: 'eventList', name: 'EventList', meta: {keepAlive: false, pc: true, type: 1}, component: EventList},
        {path: 'mergersList', name: 'MergersList', meta: {keepAlive: false, pc: true, type: 1}, component: MergersList},
        {path: 'companyList', name: 'CompanyList', meta: {keepAlive: false, pc: true, type: 1, enter_type: 203}, component: CompanyList},
        {path: 'orgList', name: 'OrgList', meta: {keepAlive: false, pc: true, type: 1, enter_type: 204}, component: OrgList},
        {path: 'hospitalList', name: 'HospitalList', meta: {keepAlive: false, pc: true, type: 1, enter_type: 205}, component: HospitalList},
        {path: 'parkList', name: 'ParkList', meta: {keepAlive: false, pc: true, type: 1, enter_type: 206}, component: ParkList},
        {path: 'hospitalDetail/:uid', name: 'HospitalDetail', meta: {keepAlive: false, pc: true, type: 1}, component: HospitalDetail},
        {path: 'tenderList', name: 'TenderList', meta: {keepAlive: false, pc: true, type: 1}, component: TenderList},
        // {path: 'diddingList', name: 'DiddingList', meta: {keepAlive: false, pc: true, type: 1}, component: DiddingList},
        {path: 'tenderDetail/:id', name: 'TenderDetail', meta: {keepAlive: false, pc: true, type: 1}, component: TenderDetail},
        {path: 'policyList', name: 'PolicyList', meta: {keepAlive: false, pc: true, type: 1}, component: PolicyList},
        {path: 'policyDetail/:uid', name: 'PolicyDetail', meta: {keepAlive: false, pc: true, type: 1}, component: PolicyDetail},
        {path: 'searchList', name: 'SearchList', meta: {keepAlive: false, pc: true, type: 1}, component: SearchList},
        {path: 'reportList', name: 'ReportList', meta: {keepAlive: false, pc: true, type: 1}, component: ReportList},
        {path: 'reportDetail/:uid', name: 'ReportDetail', meta: {keepAlive: false, pc: true, type: 1}, component: ReportDetail},
        // {path: 'userReport', name: 'UserReport', meta: {keepAlive: false, pc: true, type: 1}, component: UserReport},
        {path: 'orderList', name: 'OrderList', meta: {keepAlive: false, pc: true, type: 1}, component: OrderList},
        {path: 'openInv', name: 'OpenInv', meta: {keepAlive: false, pc: true, type: 1}, component: OpenInv,
          beforeEnter: (to, from, next) => {
            if (store.state.order_uid_arr.length == 0) {
              next({name: 'OrderList', replace: true})
            } else {
              next()
            }
          }
        },
        {path: 'buyVip', name: 'BuyVip', meta: {keepAlive: false, pc: true, type: 1}, component: BuyVip},
        {path: 'userAccount', name: 'UserAccount', meta: {keepAlive: false, pc: true, type: 1}, component: UserAccount},
        {path: 'userMain', name: 'UserMain', meta: {keepAlive: false, pc: true, type: 1}, component: UserMain},
        // {path: 'index', name: 'Index', meta: {keepAlive: false, pc: true, type: 1}, component: Index},
        {path: 'activityList', name: 'ActivityList', meta: {keepAlive: false, pc: true, type: 1}, component: ActivityList},
        {path: 'activityDetail/:uid', name: 'ActivityDetail', meta: {keepAlive: false, pc: true, type: 1}, component: ActivityDetail},
        {path: 'userProduct', name: 'UserProduct', meta: {keepAlive: false, pc: true, type: 1}, component: UserProduct},
        {path: 'userCoupon', name: 'UserCoupon', meta: {keepAlive: false, pc: true, type: 1}, component: UserCoupon},
        {path: 'workBench', name: 'WorkBench', meta: {keepAlive: false, pc: true, type: 1}, component: WorkBench},
        {path: 'feedList', name: 'FeedList', meta: {keepAlive: false, pc: true, type: 1}, component: FeedList},
        {path: 'userCollect', name: 'UserCollect', meta: {keepAlive: false, pc: true, type: 1}, component: UserCollect},
        {path: 'log', name: 'Log', meta: {keepAlive: false, pc: true, type: 1}, component: Log},
        {path: 'helpCenter', name: 'HelpCenter', meta: {keepAlive: false, pc: true, type: 1}, component: HelpCenter},
        {path: 'about', name: 'About', meta: {keepAlive: false, pc: true, type: 1}, component: About},
        {path: 'noticeList', name: 'NoticeList', meta: {keepAlive: false, pc: true, type: 1}, component: NoticeList},
        {path: 'prospectusList', name: 'ProspectusList', meta: {keepAlive: false, pc: true, type: 1}, component: ProspectusList},
        {path: 'actList', name: 'ActList', meta: {keepAlive: false, pc: true, type: 1}, component: ActList},
        {path: 'productList', name: 'ProductList', meta: {keepAlive: false, pc: true, type: 1}, component: ProductList},
        {path: 'noticeDetail/:id', name: 'NoticeDetail', meta: {keepAlive: false, pc: true, type: 1}, component: NoticeDetail},
        {path: 'industryList', name: 'IndustryList', meta: {keepAlive: false, pc: true, type: 1}, component: IndustryList},
        {path: 'stockList', name: 'StockList', meta: {keepAlive: false, pc: true, type: 1}, component: StockList},
        {path: 'financeList', name: 'FinanceList', meta: {keepAlive: false, pc: true, type: 1}, component: FinanceList},
        {path: 'contact', name: 'contact', meta: {keepAlive: false, pc: true, type: 1}, component: Contact},
        // 找公司
        {path: 'companyFilter', name: 'CompanyFilter', meta: {keepAlive: false, pc: true, type: 1}, component: CompanyFilter},
        {path: 'companyMore', name: 'CompanyMore', meta: {keepAlive: false, pc: true, type: 1}, component: CompanyMore},
        // 查赛道
        {path: 'searchTrack', name: 'searchTrack', meta: {keepAlive: false, pc: true, type: 1}, component: searchTrack}, 
        {path: 'orgLikesTrack', name: 'orgLikesTrack', meta: {keepAlive: false, pc: true, type: 1}, component: orgLikesTrack}, 
        {path: 'ipoList', name: 'ipoList', meta: {keepAlive: false, pc: true, type: 1}, component: ipoList}, 
        {path: 'trackList', name: 'trackList', meta: {keepAlive: false, pc: true, type: 1}, component: trackList}, 
        {path: 'trackDetail', name: 'trackDetail', meta: {keepAlive: false, pc: true, type: 1}, component: trackDetail}, 
        //看报告
        {path: 'reportingDetail', name: 'reportingDetail', meta: {keepAlive: false, pc: true, type: 1}, component: reportingDetail}, 
        {path: 'chartSet', name: 'chartSet', meta: {keepAlive: false, pc: true, type: 1}, component: chartSet}, 
        // 文章详情
        {path: 'articleDetail/:id', name: 'articleDetail', meta: {keepAlive: false, pc: true, type: 1}, component: ArticleDetail},
        // 收藏
        {path: 'collect', name: 'Collect', meta: {keepAlive: false, pc: true, type: 1}, component: Collect}, 
        {path: 'myAttention', name: 'MyAttention', meta: {keepAlive: false, pc: true, type: 1}, component: MyAttention}, 
        // 申请试用
        {path: 'applyTry', name: 'ApplyTry', meta: {keepAlive: false, pc: true, type: 1}, component: ApplyTry}, 
        {path: 'live', name: 'Live', meta: {keepAlive: false, pc: true, type: 1}, component: Live}, 
        {path: 'liveTheme', name: 'LiveTheme', meta: {keepAlive: false, pc: true, type: 1}, component: LiveTheme}, 
        {path: 'liveList', name: 'LiveList', meta: {keepAlive: false, pc: true, type: 1}, component: LiveList}, 
        
        {path: 'privacy', name: 'Privacy', meta: {keepAlive: false, pc: true, type: 1}, component: Privacy},
        
        {path: 'medicineList', name: 'MedicineList', meta: {keepAlive: false, pc: true, type: 1}, component: MedicineList},
        {path: 'medicineDetail/:id', name: 'MedicineDetail', meta: {keepAlive: false, pc: true, type: 1}, component: MedicineDetail},
        
        {path: 'no', name: 'NoFound', meta: {keepAlive: false, pc: true, type: 1}, component: NotFound},
        {path: '*', name: 'NotFound', meta: {keepAlive: false, pc: true, type: 1}, component: NotFound},
      ]
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition &&  to.meta.keepAlive) {
      return savedPosition
    } else {
      if (from.name != 'SpecialDetail') {
        if (to.name == 'Index') {
          if(to.hash){
            return {
              selector:to.hash
            }
          } else {
            return { x: 0, y: 0 }
          }
        } else {
          return { x: 0, y: 0 }
        }
      }
    }
  }
})
function creatUuid(len, radix) {
  let chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
  let uuid = [], i;
  radix = radix || chars.length;
  let timestamp = new Date().getTime(); // 获取当前时间戳 以防止 uuid 重复生成

  if (len) {
    // Compact form
    for (i = 0; i < len - String(timestamp).length; i++) uuid[i] = chars[0 | Math.random() * radix];
  } else {
    // rfc4122, version 4 form
    let r;

    // rfc4122 requires these characters
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
    uuid[14] = '4';
    // per rfc4122, sec. 4.1.5
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | Math.random() * 16;
        uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
      }
    }
  }
  return uuid.join('') + '-' + timestamp;
}

router.beforeEach(async (to, from, next) => {
  // let rep_string = window.location.href
  // let rep = /((<[^>]*)on[a-zA-Z]+\s*=([^>]*>)|(select\b|delete\b|update\b|create\b|insert\b|dump|declare)|(<(\"[^\"]*\"|\'[^\']*\'|[^\'\">])*>)|(window\.|document\.)|(%22|%27|\'|;)|(script|i?frame|style|html|body|title|link|meta|object))/i
  // if(rep.test(rep_string)) {
  //   console.log('过滤非法字符串域名')
  //   window.location.href = window.location.protocol + '//' + window.location.host
  // }

  if (!store.state.is_pc) { // 如果
    window.location.href = window.location.protocol + '//' + window.location.host + '/mindex'+ to.fullPath
  } else { // mobile切回pc也要变
      if(to.name == 'Viewer') {
        next()
        return
      }
      if (!store.state.dict_is) { // 第一次进来
        let cookies_uuid = Cookies.get('uuid')
        if (cookies_uuid && cookies_uuid != null) {
          store.commit('setUUid', cookies_uuid)
        } else {
          let u = creatUuid()
          Cookies.set('uuid', u, { domain: store.state.domain_path, path: '/', expires: store.state.oneYearFromNow })
          store.commit('setUUid', u)
        }
        if (!store.state.user_key) {
          let cookies_user_key = Cookies.get('user_key_'+store.state.cookie_type)
          if (cookies_user_key) {
            store.commit('updateUserKey', cookies_user_key)
            let user_info = await Arefreshlogin({user_key: cookies_user_key})
            if (user_info.code == 0) {
              store.commit('updateUser', user_info.data)
              store.commit('setUUserId', user_info.data.id)
            } else {
              this.$store.commit('updateUserKey', '')
              this.$store.commit('updateUser', '')
              this.$store.commit('updateFilter', '')
              this.$store.commit('setUUserId', null)
              Cookies.remove('user_key_'+store.state.cookie_type, { domain: store.state.domain_path, path: '/'})
            }
          } else {
            Cookies.remove('user_key_'+store.state.cookie_type, { domain: store.state.domain_path, path: '/'})
            window.localStorage.removeItem('show_scientific')
          }
        }
        if(to.name != 'SpecialDetail' && to.name != 'NewsDetail' && to.name != 'LoginTarget') {
          let res = await getDict({}, (error) => {
            // console.log('请求错误！')
          })
          if (res.status == 'success') {
            store.commit('updateDict', res.meta)
            store.commit('updateDis', true)
          } else {
            console.log('sth wrong')
          }
        }
        store.commit('updateReadList', localStorage.topic_read_uids ? JSON.parse(localStorage.topic_read_uids) : [])
      }
      store.commit('setEnterType', to.meta.enter_type || 35)
      if(store.state.user_key) {
        if ((!store.state.attention && to.name != 'LoginTarget') || to.name == 'MyAttention') {
          let res2 = await subscribeList({user_key: store.state.user_key},(error) => {
            console.log('请求错误！')
          })
          if(res2.status == 'success') {
            store.commit('updateFilter', {
              g_relation:res2.g_relation,
              group:res2.group,
              subscribe:res2.subscribe
            })
          }
        }
        // if(to.path == '/newsList' || to.path == '/attentionIndex' || to.path == '/userAccount') {
        // }
        if(to.path == '/newsList') {
          let res = await topicCount({user_key: store.state.user_key, count_type: 'entity'},(error) => {
            console.log('请求错误！')
          })
          if(res.status == 'success') {
            store.commit('topicEntityCount', res.res)
          }

          let res4 = await topicCount({user_key: store.state.user_key, count_type: 'tag'},(error) => {
            console.log('请求错误！')
          })
          if(res4.status == 'success') {
            store.commit('topicTagCount', res4.res)
          } else {
            console.log(res4.msg)
          }
        }
      }
      if(!store.state.datahotsearchkey && to.name != 'LoginTarget') {
        let res = await getMeta({name: ['datahotsearchkey']},(error) => {
          console.log('请求错误！')
        })
        if(res.status == 'success') {
          store.commit('updateDatahotsearchkey', res.meta.datahotsearchkey)
        }
      }
      // if(to.path == '/' && from.path != '/') {
      //   next({name:'Index'})
      // } else {
      //   next()
      // }
      // if(to.path == '/') {
      //   next()
      // }
      // if(to.path == '/attentionIndex') {
      //   if(!store.state.user_key) {
      //     next({name:'NewsList'})
      //   }
      // }
      next()
      
    // }
  }
})

export default router
